import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const navLinks = [{
    href: '#accueil',
    label: 'Accueil'
  }, {
    href: '#gamme',
    label: 'Notre gamme'
  }, {
    href: '#services',
    label: 'Nos services'
  }, {
    href: '#zones',
    label: "Zones d'intervention"
  }, {
    href: '#rse',
    label: 'RSE'
  }, {
    href: '#contact',
    label: 'Contact'
  }];
  return <header className="fixed top-0 w-full z-50 transition-all duration-300 bg-white/95 backdrop-blur-lg shadow-lg border-b border-gray-100 py-3 md:py-4" data-id="element-117">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 flex justify-between items-center" data-id="element-118">
        <div className="logo relative z-50" data-id="element-119">
          <a href="#" className="flex items-center group" data-id="element-120">
            <div className="relative" data-id="element-121">
              {/* Logo avec effet 3D */}
              <div className="font-bold text-2xl tracking-tight text-secondary-dark relative flex items-baseline" data-id="element-122">
                <span className="text-primary font-black text-3xl relative" data-id="element-123">
                  1001
                  <div className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-primary to-primary-dark rounded-full transform group-hover:scale-x-110 transition-transform" data-id="element-124"></div>
                </span>
                <span className="ml-2 font-light text-xl tracking-wider uppercase" data-id="element-125">
                  Palettes
                </span>
              </div>
              {/* Effet de profondeur */}
              <div className="absolute -bottom-2 left-0 w-16 h-0.5 bg-gradient-to-r from-primary/30 to-transparent blur-sm" data-id="element-126"></div>
            </div>
          </a>
        </div>

        <div className="md:hidden cursor-pointer z-50 text-secondary-dark" onClick={toggleMenu} data-id="element-127">
          {isMenuOpen ? <X size={24} data-id="element-128" /> : <Menu size={24} data-id="element-129" />}
        </div>

        <nav className={`
          fixed md:static top-0 left-0 w-full h-screen md:h-auto bg-white md:bg-transparent
          md:flex items-center justify-end transition-all duration-500 ease-in-out z-40
          ${isMenuOpen ? 'translate-x-0 opacity-100' : 'translate-x-full md:translate-x-0 opacity-0 md:opacity-100 pointer-events-none md:pointer-events-auto'}
        `} data-id="element-130">
          <ul className="flex flex-col md:flex-row items-center justify-center h-full md:h-auto gap-8 md:gap-6 lg:gap-8 list-none" data-id="element-131">
            {navLinks.map(link => <li key={link.label} data-id="element-132">
                <a href={link.href} className="font-medium text-lg md:text-sm tracking-wide relative group transition-colors text-gray-600 hover:text-primary" onClick={closeMenu} data-id="element-133">
                  {link.label}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full bg-gradient-to-r from-primary to-primary-dark" data-id="element-134"></span>
                </a>
              </li>)}
            <li className="md:hidden mt-4" data-id="element-135">
              <a href="#contact" onClick={closeMenu} className="px-8 py-3 bg-gradient-to-r from-primary to-primary-dark text-white rounded-full font-semibold shadow-lg shadow-primary/30 hover:shadow-xl hover:shadow-primary/40 transition-all" data-id="element-136">
                Demander un devis
              </a>
            </li>
          </ul>
        </nav>

        <div className="hidden md:block ml-8" data-id="element-137">
          <a href="#contact" className="relative px-6 py-2.5 rounded-full font-semibold text-sm transition-all duration-300 bg-gradient-to-r from-primary to-primary-dark text-white hover:shadow-xl hover:shadow-primary/40 hover:-translate-y-0.5 whitespace-nowrap overflow-hidden group" data-id="element-138">
            <span className="relative z-10" data-id="element-139">Demander un devis</span>
            <div className="absolute inset-0 bg-gradient-to-r from-primary-dark to-primary opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-140"></div>
          </a>
        </div>
      </div>
    </header>;
}